import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from './Header'

function VideoCheck( data ) {
    const video = useRef( null )
    const navigate = useNavigate()

    // useEffect(()=>{
    //     if( !data.user ) navigate('/')
    // },[data.user])

    useEffect(() => {
        if( data.localMedia && !data.localVideoIsChecked ) {
            let localMedia = data.localMedia
            localMedia.getAudioTracks()[0].enabled = false
            
            let videoElement = video.current
            videoElement.autoplay = true
            videoElement.srcObject = localMedia
            videoElement.play().catch((error) => {
                console.log('Error playing video:', error)
            });
        }
    }, [ data.localMedia ]) 



    if( !data.localVideoIsChecked ){
        return(
            <div className = 'videoCheckWrapper'>
            <Header headerContext='videoCheck'
                width = { data.width }
            />
            <h3 className = 'setUserMediaBeforeEntry_header'>Check out how other players will see you</h3>
            <div className = 'setUserMediaBeforeEntry_mediablock' >
                <div className = 'setUserMediaBeforeEntry_playerCover_gradient_l' >
                    <div className = 'setUserMediaBeforeEntry_playerCover' ></div>
                    <div className = 'setUserMediaBeforeEntry_cardHolder' >
                        <div className = 'setUserMediaBeforeEntry_cardLeft' ></div>
                        <div className = 'setUserMediaBeforeEntry_cardRight' ></div>
                    </div>
                </div>
                <div className = 'setUserMediaBeforeEntry_videoHolder' >
                    {   data.localMedia  ?
                        // <img className='setUserMediaBeforeEntryAvatarImage' src={ 'images/petAvatars/' + data.user?.avatar + '.jpeg' }></img>
                        //<video ref={ video } id="video-chat" className = 'setUserMediaBeforeEntry_video' controls muted></video>
                        <video ref={ video } id="video-chat" className = 'setUserMediaBeforeEntry_video'></video>

                        :
                        <img className='setUserMediaBeforeEntryAvatarImage' src={ 'images/petAvatars/' + data.user?.avatar + '.jpeg' }></img>
                    }
                    <div className = 'setUserMediaBeforeEntry_cardHolder_center' >
                        <div className = 'setUserMediaBeforeEntry_cardLeft' ></div>
                        <div className = 'setUserMediaBeforeEntry_cardRight' ></div>
                    </div>
                </div>
                <div className = 'setUserMediaBeforeEntry_playerCover_gradient_r' >
                    <div className = 'setUserMediaBeforeEntry_playerCover' ></div>
                    <div className = 'setUserMediaBeforeEntry_cardHolder' >
                        <div className = 'setUserMediaBeforeEntry_cardLeft' ></div>
                        <div className = 'setUserMediaBeforeEntry_cardRight' ></div>
                    </div>
                </div>
            </div>

            {
                data.localMedia ?
                    <button className = 'purple_button buttonBeforeEntry' onClick={ ()=> data.setlocalVideoIsChecked( true ) }><p>Let's go</p></button>
                    :
                    <button className = 'buttonBeforeEntry purple_button_dissabled' ><p>Preparing...</p></button>
            }
        </div>
    )}
}

export default VideoCheck
